import React, { useEffect, useState, createElement } from 'react';
import { Hero } from '../components/Hero';
import { PageTitle } from '../components/PageTitle';
import { CaseStudyCard } from '../components/CaseStudyCard';
import { CompanyLogos } from '../components/CompanyLogos';
import { ChevronRightIcon, ChevronLeftIcon, QuoteIcon, TrendingUpIcon, BarChart2Icon, MailIcon, BrainIcon, LightbulbIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
export function Home() {
  const featuredCaseStudies = [{
    id: '5',
    title: 'AI-Driven FinTech Platform',
    description: 'Ideated vision, design and product roadmap of new AI-driven interactive FinTech platform that translates SMB seller data into personalized business recommendations.',
    metrics: ['AI/ML integration', '+24% program adoption', '$145M projected growth'],
    icon: BrainIcon,
    iconColor: '#0096B4',
    iconBgColor: '#E0F5F8'
  }, {
    id: '6',
    title: 'Product Innovation & Development',
    description: 'Rebuilt a pre-launch product with low retailer buy-in by co-creating with 32 key opinion leaders (KOLs), driving a 180° turnaround.',
    metrics: ['2-week timeframe', '$7M incremental sales', '32 KOL collaborations'],
    icon: LightbulbIcon,
    iconColor: '#0096B4',
    iconBgColor: '#E0F5F8'
  }, {
    id: '1',
    title: 'Product Turnaround Strategy',
    description: 'Drove turnaround of $110M product platform from -12% decline to +9% growth in 6 months via organic growth plan.',
    metrics: ['+21% growth swing', '$110M product platform', '6-month timeframe'],
    icon: TrendingUpIcon,
    iconColor: '#0096B4',
    iconBgColor: '#E0F5F8'
  }];
  const highlights = [{
    title: '15+',
    subtitle: 'Products Launched',
    description: 'Ideated and launched over 15 products with $362M+ in innovation value.'
  }, {
    title: '$3B',
    subtitle: 'Portfolio Oversight',
    description: 'Oversaw strategic direction for product portfolios valued at $3B.'
  }, {
    title: '+236%',
    subtitle: 'Traffic Growth',
    description: 'Drove significant traffic increases through innovative marketing strategies.'
  }, {
    title: '+53%',
    subtitle: 'Sales Growth',
    description: 'Achieved substantial sales growth through strategic product initiatives.'
  }, {
    title: '+80%',
    subtitle: 'Weekly Active User Growth',
    description: 'Following UX/UI and algorithm revamp of self-serve consumer-facing product tool.'
  }];
  const testimonials = [{
    quote: 'She brings untempered creativity, an ability to hustle, a strong sense of ownership, sharp analytical skills, and an intuitive grasp of how to manage stakeholders that makes her a standout.',
    author: 'Leadership Team',
    company: 'Johnson & Johnson'
  }, {
    quote: 'Katalina is exceptional. Her ability to navigate ambiguity and thrive in difficult, amorphous problem spaces makes her a benchmark for our team.',
    author: 'Senior Manager',
    company: 'Verkada'
  }, {
    quote: 'Katalina consistently inspires others through three key behaviors: problem solving, fostering collaborative working relationships, and adapting to change with ease.',
    author: 'Team Lead',
    company: 'Product Development'
  }, {
    quote: 'Katalina leads with maturity, authenticity and positivity. She ensures cross-squad, cross-agency, and cross-functional collaboration by truly acting End to End. She acts with speed, with decisions based on data and rooted in consumer insights... always fast and direct while maintaining cohesiveness and partnership.',
    author: 'Director',
    company: 'Marketing'
  }, {
    quote: "Her initiative has encouraged creative thinking across marketing and demonstrates Katalina's out-of-the-box thinking and problem-solving approach; one that brings people together, is filled with enthusiasm and optimism, and rises to the occasion.",
    author: 'Marketing VP',
    company: 'Consumer Products'
  }, {
    quote: 'She knows how to frame the right question and consider multiple approaches to a problem rather than simply giving an answer.',
    author: 'Project Manager',
    company: 'Cross-Functional Team'
  }, {
    quote: "She's extremely patient, works very well across different personalities and keeps calm and positive under pressure.",
    author: 'Michael Lee',
    company: 'Procter & Gamble'
  }, {
    quote: 'Her ability to discern multiple perspectives is why I trust her voice.',
    author: 'Executive Sponsor',
    company: 'Strategic Initiative'
  }, {
    quote: "When it comes to bringing people together, you'll find no one better suited than Katalina. Her energy, warmth and enthusiasm draw others to be around her. Everyone who has had the pleasure of working with her can confirm that she not only drives the business, but she does it in an engaging manner that makes work fun.",
    author: 'Colleague',
    company: 'Johnson & Johnson'
  }, {
    quote: "Katalina's input and contribution were critical… she clearly articulated business needs, current state, and vision for future.",
    author: 'Stakeholder',
    company: 'Digital Transformation'
  }, {
    quote: "Katalina's relentless curiosity and growth mindset differentiate her… she pivoted a conversation centered around risk into one about growth and opportunity.",
    author: 'Justin',
    company: 'Johnson & Johnson'
  }, {
    quote: "She has built a reputation for breaking the norm in a way that inspires encouragement and trust. This is why she was promoted to lead a $350MM business unit's entire long-term strategy and pipeline development.",
    author: 'Senior Leadership',
    company: 'Corporate Strategy'
  }, {
    quote: "Katalina is self-motivated and isn't afraid to dig into a challenge. From there, she quickly identifies opportunities to shape a new way of working or offers creative solves to drive stronger business results.",
    author: 'James Wilson',
    company: 'Johnson & Johnson'
  }, {
    quote: 'She is one of the most responsive, creative and helpful clients I have ever had… a valuable asset — mature, personable, extremely efficient, and fun to work with.',
    author: 'Agency Partner',
    company: 'Marketing Agency'
  }, {
    quote: 'Katalina is kind, calm, helpful and personable enabling her to deliver results by inspiring and motivating others.',
    author: 'Team Member',
    company: 'Product Team'
  }, {
    quote: "She's a really strong collaborator, and she's really quick at connecting the dots.",
    author: 'Cross-Functional Partner',
    company: 'Innovation Team'
  }, {
    quote: 'Her magnetic personality is infused with gratitude and self-reflection, and I argue it is these traits that would make her an invaluable member and leader of any community.',
    author: 'Mentor',
    company: 'Leadership Development'
  }, {
    quote: "Not only is she personable and easy to get along with, she is able to form great relationships with people inside and outside the company. She works to strengthen the team relationships so that things don't get tense or stressful in a clinch.",
    author: 'Sarah Martinez',
    company: 'Amazon'
  }, {
    quote: 'Katalina is solution & big picture-oriented, and she always comes prepared with a good recommendation.',
    author: 'Rebecca Chen',
    company: 'Verkada'
  }, {
    quote: "She's our digital guru… She's hacked the process and knows how to get things done quickly.",
    author: 'Chris Johnson',
    company: 'Digital Strategist'
  }];
  // For company logos
  const logos = [{
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/2mDgT6Jnj1fQmft2sFNQf9/HBS-styleguide-primary-logo-3.png',
    alt: 'Harvard Business School'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/n1HCVPbWNrsLyxYBxE8AVc/Neutrogena_logo.svg.png',
    alt: 'Neutrogena'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/tx3qJCzrpYPAkLH26Exr9U/b5527d_d750bc34f45c45b08849886188dcdf49~mv2.png',
    alt: 'Harvard Tech Club'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/7nsuia8WXRvuhRgAcMxBXh/Clean-Clear-Logo.png',
    alt: 'Clean & Clear'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/qjQ3NGL61XuGF2ggiWYF4h/download.png',
    alt: 'MDC'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/2GVebseGXSP8JG1bqhfSrZ/images_copy.png',
    alt: 'Duke Dance Council'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/anKwkDpEzmsscY6BwWBgCx/Productboard.webp',
    alt: 'Productboard'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/i5WzGJ66vXg6G8Sg9Xrw5m/Verkada-Logo-Horiz-Black-RGB-1.png',
    alt: 'Verkada'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/oHNv1V6nNvGRnuGYKufzNb/download_copy.png',
    alt: 'Duke University Logo'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/kYQnoSnsJyV9F6kcEjCSix/Walmart_logo_%282008%29.svg',
    alt: 'Walmart'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/mofctB6UiTS9PqHCKegqrQ/Costco_Wholesale_logo_2010-10-26.svg.webp',
    alt: 'Costco'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/eafNfcKtXzyZF92vebG8MA/Target-Logo-1974.png',
    alt: 'Target'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/opXtvU7TqF5VFr8n9QkhRp/TikTok_logo.svg.png',
    alt: 'TikTok'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/h4f1sRJw9gGRkWKzecnsVU/Instagram-logo-3.webp',
    alt: 'Instagram'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/5YSZNzqVya5Tz5JpCyzYCY/Facebook-Logosu.png',
    alt: 'Facebook'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/5B7Cwmx5BM4XTvyH3MsWTz/Google_2015_logo.svg.webp',
    alt: 'Google'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/uLv8eFp2Boca9VsUo9gPbB/Johnson_and_Johnson_Logo.svg',
    alt: 'Johnson & Johnson'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/4ig99mnQNwRbxvzKTJQcSJ/VKxNigKPQEGsGjtsmYUq.png',
    alt: 'Harvard Tech Club'
  }];
  // State for testimonial carousel
  const [activeIndex, setActiveIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  // Auto-rotate testimonials
  useEffect(() => {
    const interval = setInterval(() => {
      if (!isAnimating) {
        setActiveIndex(current => (current + 1) % testimonials.length);
      }
    }, 8000);
    return () => clearInterval(interval);
  }, [isAnimating, testimonials.length]);
  // Navigation functions
  const goToNext = () => {
    if (isAnimating) return;
    setIsAnimating(true);
    setActiveIndex(current => (current + 1) % testimonials.length);
    setTimeout(() => setIsAnimating(false), 500);
  };
  const goToPrev = () => {
    if (isAnimating) return;
    setIsAnimating(true);
    setActiveIndex(current => (current - 1 + testimonials.length) % testimonials.length);
    setTimeout(() => setIsAnimating(false), 500);
  };
  const goToSlide = index => {
    if (isAnimating || index === activeIndex) return;
    setIsAnimating(true);
    setActiveIndex(index);
    setTimeout(() => setIsAnimating(false), 500);
  };
  return <div data-id="element-1300">
      <PageTitle canonical="/" description="Product Leader Sparking Growth & Innovation. Helping companies win the hearts of customers by building products that thrive — driving adoption, loyalty, and multimillion-dollar growth." keywords="product leader, product strategy, innovation, growth, Fortune 50, unicorn, startup, Katalina Bock" data-id="element-1301" />
      <Helmet data-id="element-1302">
        <script type="application/ld+json" data-id="element-1303">
          {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'Person',
          name: 'Katalina Bock',
          url: 'https://katalinabock.com',
          jobTitle: 'Product Leader',
          worksFor: {
            '@type': 'Organization',
            name: 'Verkada'
          },
          description: 'Product leader specializing in product strategy, growth, and innovation with impact across Fortune 50, unicorn, and startup companies.',
          sameAs: ['https://www.linkedin.com/in/katalinabock'
          // Add other social profiles here
          ]
        })}
        </script>
      </Helmet>
      <Hero data-id="element-1304" />
      <div id="content" className="py-12 bg-white" data-id="element-1305">
        <div className="container mx-auto px-4" data-id="element-1306">
          <h2 className="text-3xl font-bold text-gray-900 mb-6 text-center" data-id="element-1307">
            Career Highlights
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6 mb-16" data-id="element-1308">
            {highlights.map((highlight, index) => <div key={index} className="bg-[#E0F5F8] p-6 rounded-lg text-center" data-id="element-1309">
                <div className="text-3xl font-bold text-[#0096B4] mb-2" data-id="element-1310">
                  {highlight.title}
                </div>
                <div className="text-lg font-medium text-gray-800 mb-2" data-id="element-1311">
                  {highlight.subtitle}
                </div>
                <p className="text-gray-600" data-id="element-1312">{highlight.description}</p>
              </div>)}
          </div>
          <div className="mb-16 text-center" data-id="element-1313">
            <p className="text-xl text-gray-700 mb-6 max-w-3xl mx-auto" data-id="element-1314">
              What sets me apart is my ambidextrous approach: I fuse consumer
              psychology with data, strategy with execution, and product with
              marketing. This has led to market leadership across Fortune 50s,
              unicorns, and startups, including both B2C and B2B tech, retail,
              and CPG verticals. I dig into the "why" behind behavior, translate
              it into roadmaps and campaigns, and align cross-functional teams
              to deliver products that not only launch, but thrive. Whether
              turning around a $110M Neutrogena platform, designing Amazon's
              $145M FinTech dashboard, or scaling new GTM strategies at Verkada,
              I've built a career on making complex problems simple,
              market-ready, and customer-loved.
            </p>
            <Link to="/about" className="inline-flex items-center text-[#0096B4] font-medium hover:text-[#00778F] transition-colors duration-200" data-id="element-1315">
              Learn more about my approach
              <ChevronRightIcon size={16} className="ml-1" data-id="element-1316" />
            </Link>
          </div>
        </div>
      </div>
      <section className="py-16 relative overflow-hidden text-white" data-id="element-1317">
        {/* Gradient background */}
        <div className="absolute inset-0 bg-gradient-to-r from-[#0096B4] to-[#7DCCD8] z-0" data-id="element-1318"></div>
        {/* Background decorative elements */}
        <div className="absolute inset-0 z-0 opacity-15" data-id="element-1319">
          <img src="https://uploadthingy.s3.amazonaws.com/quote-bubbles-background.png" alt="" className="absolute right-0 top-0 h-full w-auto object-cover opacity-20" data-id="element-1320" />
          <div className="absolute top-20 left-10 w-64 h-64 rounded-full bg-white opacity-10 blur-3xl" data-id="element-1321"></div>
          <div className="absolute bottom-10 right-20 w-80 h-80 rounded-full bg-white opacity-10 blur-3xl" data-id="element-1322"></div>
        </div>
        <div className="container mx-auto px-4 relative z-10" data-id="element-1323">
          <h2 className="text-3xl font-bold mb-2 text-center" data-id="element-1324">
            What People Say
          </h2>
          <p className="text-white opacity-90 text-center mb-12 max-w-2xl mx-auto" data-id="element-1325">
            Feedback from colleagues and clients who have experienced my
            approach to product leadership and innovation.
          </p>
          {/* Testimonial Carousel - Updated to look like quote bubbles */}
          <div className="relative overflow-hidden" data-id="element-1326">
            <div className="testimonial-carousel flex" data-id="element-1327">
              {/* Duplicate testimonials to create seamless loop */}
              {[...testimonials, ...testimonials].map((testimonial, index) => <div key={index} className="w-1/2 max-w-md flex-shrink-0 px-4" data-id="element-1328">
                  <div className="bg-white p-6 rounded-lg shadow-md relative h-full" data-id="element-1329">
                    <div className="absolute top-4 left-4 text-[#7DCCD8]" data-id="element-1330">
                      <QuoteIcon size={30} data-id="element-1331" />
                    </div>
                    <div className="pt-8 px-2" data-id="element-1332">
                      <p className="text-gray-700 italic text-lg" data-id="element-1333">
                        {testimonial.quote}
                      </p>
                    </div>
                    {/* Speech bubble tail */}
                    <div className="absolute -bottom-4 left-10 w-0 h-0 border-l-[12px] border-l-transparent border-t-[16px] border-t-white border-r-[12px] border-r-transparent" data-id="element-1334"></div>
                  </div>
                </div>)}
            </div>
          </div>
          <style jsx="true" data-id="element-1335">{`
            .testimonial-carousel {
              animation: testimonial-scroll 120s linear infinite;
              width: max-content;
            }
            @keyframes testimonial-scroll {
              0% {
                transform: translateX(0);
              }
              100% {
                transform: translateX(-50%);
              }
            }
          `}</style>
        </div>
      </section>
      <section id="case-studies" className="py-10 bg-[#E0F5F8]" data-id="element-1336">
        <div className="container mx-auto px-4" data-id="element-1337">
          <h2 className="text-3xl font-bold text-gray-900 mb-2 text-center" data-id="element-1338">
            Featured Work
          </h2>
          <p className="text-gray-600 text-center mb-8 max-w-2xl mx-auto" data-id="element-1339">
            Explore some of my most impactful projects that showcase my approach
            to product management, growth strategies, and cross-functional
            leadership.
          </p>
          {/* Updated Case Study Cards - Horizontal Layout */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8" data-id="element-1340">
            {featuredCaseStudies.map(caseStudy => <div key={caseStudy.id} className="bg-white rounded-lg shadow-lg overflow-hidden transition-all duration-300 hover:shadow-xl flex flex-col" data-id="element-1341">
                <div className="p-6 flex flex-col h-full" data-id="element-1342">
                  <div className="flex items-center mb-4" data-id="element-1343">
                    <div className="mr-4 p-2 rounded-full" style={{
                  backgroundColor: caseStudy.iconBgColor
                }} data-id="element-1344">
                      {createElement(caseStudy.icon, {
                    size: 32,
                    color: caseStudy.iconColor,
                    strokeWidth: 1.5
                  })}
                    </div>
                    <h3 className="text-xl font-bold text-gray-900" data-id="element-1345">
                      {caseStudy.title}
                    </h3>
                  </div>
                  <p className="text-gray-700 mb-4 text-sm flex-grow" data-id="element-1346">
                    {caseStudy.description}
                  </p>
                  <div className="mb-4" data-id="element-1347">
                    {caseStudy.metrics.map((metric, idx) => <div key={idx} className="flex items-center mb-1" data-id="element-1348">
                        <div className="w-2 h-2 rounded-full bg-[#0096B4] mr-2" data-id="element-1349"></div>
                        <span className="text-gray-700 text-sm" data-id="element-1350">{metric}</span>
                      </div>)}
                  </div>
                  <Link to={`/case-study-${caseStudy.id}`} className="inline-flex items-center bg-[#0096B4] text-white px-4 py-2 rounded-md font-medium hover:bg-[#00778F] transition-colors duration-200 self-start text-sm mt-auto" data-id="element-1351">
                    View Case Study
                    <ChevronRightIcon size={14} className="ml-1" data-id="element-1352" />
                  </Link>
                </div>
              </div>)}
          </div>
          <div className="text-center" data-id="element-1353">
            <Link to="/portfolio" className="bg-[#0096B4] hover:bg-[#00778F] text-white px-6 py-3 rounded-md font-medium transition-colors duration-200 inline-flex items-center" data-id="element-1354">
              View All Case Studies
              <ChevronRightIcon size={18} className="ml-2" data-id="element-1355" />
            </Link>
          </div>
        </div>
      </section>
      <section className="py-16 bg-white" data-id="element-1356">
        <div className="container mx-auto px-4" data-id="element-1357">
          <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center" data-id="element-1358">
            Companies I've Worked With
          </h2>
          <div className="relative overflow-hidden" data-id="element-1359">
            <div className="logo-carousel flex items-center" data-id="element-1360">
              {[...logos, ...logos].map((logo, index) => <div key={index} className="mx-6 flex-shrink-0" data-id="element-1361">
                  <img src={logo.src} alt={logo.alt} className="h-16 w-auto object-contain" data-id="element-1362" />
                </div>)}
            </div>
          </div>
          <style jsx="true" data-id="element-1363">{`
            .logo-carousel {
              animation: scroll 20s linear infinite;
              width: max-content;
            }
            @keyframes scroll {
              0% {
                transform: translateX(0);
              }
              100% {
                transform: translateX(-50%);
              }
            }
          `}</style>
        </div>
      </section>
    </div>;
}